import React from 'react';
import { Checkbox } from 'antd';
import FormItem from '../FormItem/FormItem';

const CheckboxField = ({
  label = '',
  name,
  form,
  options,
  colon = false,
  className,
  text,
  ...props
}) => {
  return (
    <FormItem {...props} colon={colon} label={label} className={className}>
      {form.getFieldDecorator(name, { valuePropName: 'checked', ...options })(
        <Checkbox>{text}</Checkbox>
      )}
    </FormItem>
  );
};

export default CheckboxField;
